<template> 
  <div class="content" :style="navbarWithName ? 'margin-left: 150px !important; margin-right: auto !important;' : ''"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    
  <v-snackbar v-model="alertSuccess" :timeout="4000" top right color='primary' >
      <v-icon x-medium class="white--text">mdi-checkbox-marked-circle</v-icon>    <span>{{ alert_err_attention }}</span>
  </v-snackbar>
  <v-snackbar v-model="alertFailed" :timeout="4000" top right color='red' >
    <v-icon x-medium class="white--text">mdi-minus-circle</v-icon>   <span>{{ alert_err_attention }}</span>
  </v-snackbar>
  <v-breadcrumbs :items="page" class="ml-2 mt-0 pt-0"></v-breadcrumbs>
    <template >
      <v-toolbar flat > 
          <v-toolbar-title style="margin-left: 20px;"><v-icon class="mr-2">mdi-account-badge</v-icon>{{ this.$store.state.title }}</v-toolbar-title>
          <v-spacer></v-spacer>
            <v-flex lg3>
              <v-text-field class="pt-3 mr-4" v-model="search" append-icon="mdi-magnify" label="Search"></v-text-field>
            </v-flex>
            <v-dialog v-model="dialog" max-width="700px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn 
                  v-show=insertact
                  outlined
                  rounded
                  small
                  color="#0471A5"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                  > 
                  Add New User Management
                  <v-icon class="ml-2">mdi-account-plus-outline</v-icon>
                </v-btn>
              </template>
              <v-card>
                  <v-card-title>
                    <v-card-title><span class="text-h6">{{ formTitle }}</span></v-card-title>
                  </v-card-title>
                  <v-card-text class="overflow-card" style="max-height: 600px; overflow-y: auto;">
                      <v-form class="ml-2" ref="form" lazy-validation>
                        <v-container>
                          <h4 class="mb-4" style="color: #0471A5;">User Information</h4>
                          <v-divider></v-divider>
                          <v-row class="mt-4">
                            <v-col cols="12" md="6">
                              <v-text-field dense
                                prepend-inner-icon="mdi-format-text-variant"
                                outlined
                                v-model="inputitem.nik" 
                                :rules="nikrules"
                                hint="Write NIK(Nomor Induk Kepegawaian) *harus diisi"
                                label="NIK"
                                required
                                persistent-hint
                                v-on:keypress="isLetter($event)"
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12" md="6">
                              <v-text-field dense
                                prepend-inner-icon="mdi-format-text-variant"
                                outlined
                                v-model="inputitem.fullname" 
                                label="Fullname"
                                :rules="fullnamerules"
                                hint="Write user fullname *harus diisi"
                                required
                                persistent-hint
                              ></v-text-field>
                            </v-col>
                          </v-row>

                          <v-row>
                            <v-col cols="12" md="6">
                              <v-text-field dense
                                prepend-inner-icon="mdi-office-building-outline"
                                outlined
                                v-model="inputitem.namadepartemen" 
                                hint="Nama Departement"
                                :rules="namadepartemenrules"
                                required
                                persistent-hint
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <h4 class="my-4" style="color: #0471A5;">User Account Data</h4>
                          <v-divider></v-divider>
                          <v-row class="mt-4">
                            <v-col cols="12" md="6">
                              <v-text-field dense
                                prepend-inner-icon="mdi-account"
                                outlined
                                label="Nama User"
                                hint="Write user login account *harus diisi"
                                v-model="inputitem.username" 
                                :rules="usernamerules"
                                required
                                persistent-hint
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12" md="6">
                              <v-select 
                                dense 
                                outlined 
                                :items="grouprole" 
                                item-text="name_grouprole" 
                                item-value="valuegrouprole" 
                                v-model="group_id" 
                                :rules="groupid"
                                label="Group Role"
                                hint="Select user workgroup" persistent-hint
                              ></v-select>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-text-field
                                outlined
                                v-model="password"
                                :append-icon="showpassword ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="password_rules"
                                :type="showpassword ? 'text' : 'password'"
                                name="input-10-1"
                                label="Password"
                                hint="Set user password Password merupakan kombinasi angka dan huruf"
                                persistent-hint
                                counter
                                @click:append="showpassword = !showpassword"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-select 
                                dense 
                                outlined 
                                :items="loginstatus"
                                item-text="name_loginstatus" 
                                item-value="valueloginstatus" 
                                v-model="loginstatusinput" 
                                label="Login Status"
                                hint="Set user login status manually, set to N to clear user session *harus diisi" persistent-hint
                              ></v-select>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-select 
                                dense 
                                outlined 
                                :items="blockstatus"
                                item-text="name_blockstatus" 
                                item-value="valueblockstatus" 
                                v-model="is_blok" 
                                label="Block Status"
                                hint="Set user block status *harus diisi" persistent-hint
                              ></v-select>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-select 
                                dense 
                                outlined 
                                :items="pushchangepassword"
                                item-text="name_changepassword" 
                                item-value="valuechangepassword" 
                                v-model="first_login" 
                                label="Push Change Password"
                                hint="Force user to change password" persistent-hint
                              ></v-select>
                            </v-col>
                          </v-row>
                          <h4 class="my-4" style="color: #0471A5;">Konektivitas</h4>
                          <v-divider></v-divider>
                          <v-row class="mt-4">
                            <v-col cols="12" md="6">
                              <v-text-field dense
                                prepend-inner-icon="mdi-phone"
                                outlined
                                v-model="inputitem.mobilephone" 
                                :rules="mobilephonerules"
                                hint="Write user mobile phone"
                                required
                                persistent-hint
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-text-field dense
                                prepend-inner-icon="mdi-email"
                                outlined
                                v-model="inputitem.emailaccount" 
                                :rules="emailaccount_rules"
                                hint="Write user email account"
                                required
                                persistent-hint
                              ></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row class="mt-4">
                            <v-col cols="12" md="6">
                              <v-text-field dense
                                prepend-inner-icon="mdi-skype"
                                outlined
                                v-model="inputitem.skypeid" 
                                :rules="skypeidrole"
                                hint="Write Skype ID/account"
                                label="Skype ID"
                                required
                                persistent-hint
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                              <v-text-field dense
                                prepend-inner-icon="mdi-google"
                                outlined
                                v-model="inputitem.googleid" 
                                hint="Write User google account"
                                label="Google Account"
                                required
                                persistent-hint
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                  </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="py-3">
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" style="width: 90px;" rounded outlined dense @click="close">
                    Cancel
                  </v-btn>
                  <v-btn color="blue darken-1" style="width: 90px;" rounded dark dense :loading="btnload" @click="save">
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog >

            
      </v-toolbar> 
    </template>
    <v-data-table 
    :headers="headers" 
    :items="usermanagement" 
    :search="search" 
    sort-by="username" 
    class="ml-6 mr-6 mt-4 rounded-lg"
    :loading="tableLoading"
    loading-text="Loading data..."
    >
      <template v-slot:top>
          <v-dialog v-model="dialogDelete" width="330px"> 
            <v-card class="text-center align-center justify-center pa-6 rounded-lg" width="330px">
              <v-avatar class="color-avatar3 my-4" size="62">
                <v-icon x-large class="white--text">mdi-alert-octagon</v-icon>
              </v-avatar> 
              <div class="text-center text-h6 align-center justify-center font-weight-medium">
                Confirm Deletion
              </div>
              <v-card-text class="align-center justify-center mt-2">
                Are you sure you want to permanently delete this item?
              </v-card-text>
              <v-divider class="mt-4" style=""></v-divider>
              <v-card-actions class="align-center justify-center">
                <v-btn rounded class="my-3 btn-ok" width="90px" dark @click="deleteItemConfirm">
                  OK
                </v-btn>
                <v-btn rounded outlined class="my-3" width="90px" color="red" dark @click="closeDelete">
                  Cancel
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon  v-show=viewact class="mr-2" small>
          mdi-eye
        </v-icon>
        <v-icon small v-show=updateact @click="editItem(item.USER_ID)">
          mdi-pencil
        </v-icon>
        <v-icon small v-show=deleteact @click="deleteItem(item.USER_ID)">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">
          Reset
        </v-btn>
      </template>
    </v-data-table>
    <Notification  ref="alert"></Notification>
  </div>
</template>
<script>
import Notification from  '@/components/Notification';
import { decryptionData } from '@/components/utils/utils.js';
import axios from "axios";
import { mapGetters } from 'vuex';
  export default {
    components: {
      Notification: Notification
    },
    data: () => ({
      btnload:false,
      alertSuccess:'',
      alertFailed:'',
      alert_err_attention: "",

      deleteact: false,
      insertact: false,
      updateact: false,
      viewact: false,
      nikrules: [
        v => !!v || 'Nik is required',
        v => (!isNaN(parseFloat(v)) && v >= 0 ) || 'Nik must be less than number',//validasi nuber
        v => (v && v.length >= 16) || 'Nik minimum 16 characters',
        
      ],
      fullnamerules: [
        v => !!v || 'Fullname is required',
        v => /[a-zA-Z0-9.@_ -]+$/.test(v) || 'Input may contain letters, numbers, spaces, and special characters (.@_-)',
      ],
      namadepartemenrules: [
          v => /^[\w\s]+$/.test(v) || 'Input must only contain alphabets, numeric and space',
      ],
      usernamerules: [
        v => !!v || 'Username is required',
        v => /^[\w\s]+$/.test(v) || 'Input must only contain alphabets, numeric and space',
      ],
      groupid: [
        v => !!v || 'Group is required',
        v => /^[\w\s]+$/.test(v) || 'Input must only contain alphabets, numeric and space',
      ],
      password_rules: [
        v => !!v || 'Password is required',
        v => (v && v.length >= 6) || 'Password must be at least 6 characters',

      ],
      mobilephonerules: [
          v => (!isNaN(parseFloat(v)) && v >= 0 ) || 'Input must be less than number',//validasi nuber
          v => (v && v.length <= 13) || 'Input maximum 13 characters',
      ],
      emailaccount_rules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      dialog: false,
      dialogDelete: false,
      first_login: 'Y',
      pushchangepassword: [//choice select
          {valuechangepassword: 'Y', name_changepassword: "Yes" },
          {valuechangepassword: 'N', name_changepassword: "No" }
        ],
      is_blok:'Y',
      blockstatus: [//choice select
          {valueblockstatus: 'Y', name_blockstatus: "Yes" },
          {valueblockstatus: 'N', name_blockstatus: "No" }
        ],
        
      loginstatusinput:'Y',
      loginstatus: [//choice select
          {valueloginstatus: 'Y', name_loginstatus: "Yes" },
          {valueloginstatus: 'N', name_loginstatus: "No" }
        ],
        
      showpassword: false,
      password: 'Password',
      group_id: '',
      grouprole: [//choice select
        {
          valuegrouprole: '', 
          name_grouprole: '' 
        }
      ],
      rolename: ['ADMIN', 'USER', 'REVIEWER'],
      search:'',
      headers: [
        { text: 'Username', value: 'USERNAME' },
        { text: 'Fullname', value: 'FULLNAME' },
        { text: 'E-mail', value: 'EMAIL' },
        { text: 'mobile', value: 'MOBILE' },
        { text: 'Created Date', value: 'CREATED_DATE' },
        { text: 'Last Login', value: 'LAST_LOGIN' },
        { text: 'Last Activity', value: 'LAST_ACTIVITY' },
        { text: 'Last Module', value: 'LAST_MODULE' },
        { text: 'Is Login', value: 'IS_LOGIN' },
        { text: 'Is Block', value: 'IS_BLOCK' },
        { text: 'Group', value: 'GROUP_NAME' },
        { text: 'Actions', value: 'actions', width: '200px', sortable: false },
      ],
      usermanagement: [],
      id_user_management:'',
      username_old:'',
      salt:'',
      editedIndex: -1,
      inputitem: {
      },
      defaultItem: {
        username: '',
        fullname: '',
        email: '',
        mobile: '',
        createdate: '',
        lastlogin: '',
        lastactivity: '',
        lastmodule: '',
        islogin: '',
        isblock: '',
        group: '',
      },
    }),
    computed: {
      
      page() {
        return this.$store.state.breadcrumbs
      },
      ...mapGetters(['navbarWithName']), // Accessing navbarWithName from Vuex
      formTitle () {
        return this.editedIndex === -1 ? 'Data User' : 'Update User'
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    created () {
      this.initialize()
    },
    methods: {
    async initialize () {
      this.tableLoading = true;
      this.usermanagement = [];
      axios.get("users",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            // this.usermanagement = response.data.data //untuk table
            
            let res = decryptionData(response.data.token);
            this.usermanagement = res.result;
            // ----- selected group ----
            let result = '';
            let arr_data = [];
            if(res.role_group.length > 0){
              for (let i = 0; i <  res.role_group.length; i++) {  
                  if(i == 1){
                    this.group_id = (res.role_group[i].GROUP_ID);
                  }
                  result = {
                    valuegrouprole : res.role_group[i].GROUP_ID,
                    name_grouprole : res.role_group[i].GROUP_NAME
                  };
                  arr_data.push(result);
              }
              // console.log(arr_data);
              this.grouprole= arr_data;
            }
            // ----- end selected group ----
            setTimeout(() =>{
              this.loading = false
            // end loading 
            },1000)
            this.tableLoading = false;
            if(localStorage.getItem('authactdeletedt') == 1){ this.deleteact = true }
            if(localStorage.getItem('authactinsert') == 1){ this.insertact = true }
            if(localStorage.getItem('authactupdate') == 1){ this.updateact = true }
            if(localStorage.getItem('authactview') == 1){ this.viewact = true }
          })
          .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },
      // end select 
      deleteItem (item) {
        this.id_user_management = item
        this.editedIndex = this.usermanagement.indexOf(item)
        this.inputitem = Object.assign({}, item)
        this.dialogDelete = true
      },
      deleteItemConfirm () {
        this.usermanagement.splice(this.editedIndex, 1)
        
        axios({
          method: "delete",
          url: "/userManagement",
          data: {
            id: this.id_user_management
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
          // handle success
              var status = response.data.status
              var messages = response.data.msg
              if(status == 200){
                this.alertSuccess = true;
                this.alert_err_attention =  messages;
                this.closeDelete()
              }else{
                  this.alertFailed = true;
                  this.alert_err_attention =  messages;
                  this.closeDelete()
              } 
              this.initialize();
        })
        .catch(function (error) {
          // handle error
              this.alertFailed = true;
              this.alert_err_attention =  'Delete Failed '+error;
              this.closeDelete()
        })
        this.closeDelete()
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.inputitem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      editItem (item) {
        this.id_user_management = item
        this.editedIndex = 1
        // this.editedIndex = this.usermanagement.indexOf(item)
        this.inputitem = Object.assign({}, item)
        axios({
          method: "put",
          url: "/userManagement",
          data: {
            id: item
          },
          headers:{'auth-token':localStorage.getItem('token_app')},
          dataType: 'json'
        })
        .then((response) => {
            // const dat = response.data;
            
            let res = decryptionData(response.data.token);
            const dat = res.result;
            this.id_user_management = dat.USER_ID;
            this.username_old = dat.USERNAME;
            this.inputitem = {
              nik:dat.NIK,
              namadepartemen:dat.DEPARTMENT_NAME,
              fullname:dat.FULLNAME,
              username:dat.USERNAME,
              mobilephone:dat.MOBILE,
              emailaccount:dat.EMAIL,
              skypeid:dat.SKYPE_ID,
              googleid:dat.GOOGLE_ID,
            }
            this.group_id =dat.GROUP_ID;
            this.password =dat.PASS;
            this.salt =dat.SALT;
            this.loginstatusinput =dat.IS_LOGIN;
            this.is_blok =dat.IS_BLOCK;
            this.first_login =dat.FIRST_LOGIN;
            setTimeout(() =>{
              this.loading = false
            },1000)
          
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
        this.dialog = true
      },
      save () {
        
        const isValid = this.$refs.form.validate();
        if (this.editedIndex > -1) {
          
          if (isValid) {
            this.btnload = true
              Object.assign(this.usermanagement[this.editedIndex], this.inputitem)
              axios.put("/userManagement/update", 
                {
                  
                  user_id:this.id_user_management,
                  nik:this.inputitem.nik,
                  departemen_name:this.inputitem.namadepartemen,
                  fullname:this.inputitem.fullname,
                  username_old:this.username_old,
                  username:this.inputitem.username,
                  password:this.password,
                  salt:this.salt,
                  is_blok:this.is_blok,
                  is_login:this.loginstatusinput,
                  group_id:this.group_id,
                  first_login:this.first_login,
                  mobile:this.inputitem.mobilephone,
                  skypye_id:this.inputitem.skypeid,
                  email:this.inputitem.emailaccount,
                  google_id:this.inputitem.group_id,
                  
                },
                
                {headers:{'auth-token':localStorage.getItem('token_app')}},
                {dataType: 'json'}
                )
              .then((response) => {
                
                  this.initialize()
                  this.$router.push('/usermanagement');
                  var status = response.data.status
                  var messages = response.data.msg
                  if(status == 200){
                    this.alertSuccess = true;
                    this.alert_err_attention =  messages;
                    this.btnload = false
                    this.close()
                  }else{
                      this.alertFailed = true;
                      this.alert_err_attention =  messages;
                      this.btnload = false
                      this.close()
                  } 
                })
              .catch((e) => {
                    switch (e.response.status) {
                            case 404:
                                  this.$refs.alert.error_login(404);
                                break;
                            case 403:
                                  this.$refs.alert.error_login(403);
                                break;
                            case 400:
                                  this.alertFailed = true;
                                  this.alert_err_attention =  e.response.data.msg;
                                  this.btnload = false
                                  this.close()
                                break;
                            default:
                                console.log('some other error');  // end up here all the time
                                break;
                        }
                this.errors=e.response.data.msg;
              });
          }
        } else {
          if (isValid) {
            this.btnload = true
              axios.post("/userManagement", 
                {
                  nik:this.inputitem.nik,
                  departemen_name:this.inputitem.departemen_name,
                  fullname:this.inputitem.fullname,
                  username:this.inputitem.username,
                  password:this.password,
                  is_block:this.is_blok,
                  group_id:this.group_id,
                  first_login:this.first_login,
                  mobile:this.inputitem.mobilephone,
                  skypye_id:this.inputitem.skypeid,
                  google_id:this.inputitem.googleid,
                  email:this.inputitem.emailaccount,
                  
                },
                { headers:{'auth-token':localStorage.getItem('token_app')}},
                {dataType: 'json'}
                )
              .then((response) => {
                  this.$router.push('/usermanagement');
                  var status = response.data.status
                  var messages = response.data.msg
                  if(status == 200){
                    this.alertSuccess = true;
                    this.alert_err_attention =  messages;
                    this.btnload = false
                    this.close()
                  }else{
                      this.alertFailed = true;
                      this.alert_err_attention =  messages;
                      this.btnload = false
                      this.close()
                  } 
                })
              .catch((e) => {
                    switch (e.response.status) {
                        case 404:
                              this.$refs.alert.error_login(404);
                            break;
                        case 403:
                              this.$refs.alert.error_login(403);
                            break;
                        case 400:
                              this.alertFailed = true;
                              this.alert_err_attention =  e.response.data.msg;
                              this.btnload = false
                              this.close()
                            break;
                        default:
                            console.log('some other error');  // end up here all the time
                            break;
                        }
                this.errors=e.response.data.msg;
              });
              this.initialize();
          }
        
        }
      },
      close () {
        this.$refs.form.reset()
        this.dialog = false
        this.$nextTick(() => {
          this.inputitem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
    },
  }
</script>


<style scoped>
.btn-ok{
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
.v-avatar.color-avatar3
{
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(to bottom, #ff8b8b, #ff8284, #ff787d, #ff6e76, #ff646f, #ff5c6a, #ff5464, #ff4b5f, #ff4359, #ff3b54, #ff314e, #ff2648);
}
</style>